/**
 * Hizmet kisayollari: "Konteyner", "Genel Kargo / Dokme Yuk" gibi baglantilar Hizmetler sayfasinda
 * ilgili hizmet bolumune gider (/hizmetler#<hizmet-kodu>). Bolum kimligi Hizmetler sayfasindaki
 * .service-block id'si ile aynidir (hizmet slug'i, yoksa id). Sayfaya gelince App.tsx ScrollToTop
 * adresteki bolume kaydirir. Ana sayfa kisayol seridi ve alt bilgi (footer) ayni eslestirmeyi kullanir.
 */
export const SERVICE_LINK_SPECS = [
  { label: 'Konteyner', keys: ['konteyner'] },
  { label: 'Genel Kargo / Dökme Yük', keys: ['dokme', 'genel kargo'] },
  { label: 'Proje Kargo', keys: ['proje'] },
  { label: 'Antrepo, Depo ve Silo', keys: ['antrepo', 'depo', 'silo'] },
  { label: 'Atık Alım', keys: ['atik'] },
] as const;

/**
 * Alt bilgi gibi diger yerlerdeki hizmet baglantilari icin taninan tum hizmetler: ana sayfa
 * seridindeki besli + CFS. (Serit SERVICE_LINK_SPECS'i kullanir; CFS seride eklenmez.)
 */
export const SERVICE_SECTION_SPECS = [...SERVICE_LINK_SPECS, { label: 'CFS', keys: ['cfs'] }] as const;

export type ServiceLinkTarget = { label: string; path: string };

/** Turkce harfleri sadelestirir (karsilastirma icin) */
export function simplifyLabel(value: string): string {
  return value
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g');
}

/** Yayindaki hizmetlerden Hizmetler sayfasi bolum adresleri */
export function serviceAnchorTargets(
  services: Array<{ title: string; slug?: string; id: number | string; isPublished?: boolean }>,
): ServiceLinkTarget[] {
  return services
    .filter((item) => item.isPublished !== false)
    .map((item) => ({ label: item.title, path: `/hizmetler#${item.slug || item.id}` }));
}

/** Anahtar kelimelerden biri hizmetin basliginda veya slug'inda geciyorsa o hizmetin bolum adresi */
export function findServiceAnchor(keys: readonly string[], targets: ServiceLinkTarget[]): string | undefined {
  // Baslik dile gore degisebildigi icin slug (path) da eslesmeye katilir
  return targets.find((item) =>
    keys.some((key) => simplifyLabel(`${item.label} ${item.path.replace(/-/g, ' ')}`).includes(key)),
  )?.path;
}

/**
 * Bir baglanti etiketi bilinen bir hizmet kisayoluna karsilik geliyorsa (orn. "Konteyner") ve
 * baglanti Hizmetler sayfasinin kendisine gidiyorsa, ilgili bolumun adresini dondurur.
 * Aksi halde verilen adres aynen doner (dis linkler, baska sayfalar, zaten #bolum iceren adresler).
 */
export function serviceSectionHref(label: string, path: string, targets: ServiceLinkTarget[]): string {
  const clean = path.trim();
  if (!/^\/hizmetler\/?$/i.test(clean)) return path;
  const simple = simplifyLabel(label);
  const spec = SERVICE_SECTION_SPECS.find((item) => item.keys.some((key) => simple.includes(key)));
  return (spec && findServiceAnchor(spec.keys, targets)) || path;
}
